import { render, staticRenderFns } from "./method.vue?vue&type=template&id=71f61870&scoped=true&"
import script from "./method.vue?vue&type=script&lang=js&"
export * from "./method.vue?vue&type=script&lang=js&"
import style0 from "./method.vue?vue&type=style&index=0&id=71f61870&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f61870",
  null
  
)

export default component.exports